import type { FormDrawerProps } from '../../FormDrawer';
import { AnrokConfigurationFormSchema } from './AnrokConfigurationFormSchema';
import { AnrokConfigurationFooter } from './components/AnrokConfigurationFooter';
import { AnrokConfigurationForm } from './components/AnrokConfigurationForm';

export const ConfigureAnrokComponents: FormDrawerProps = {
  zodSchema: AnrokConfigurationFormSchema,
  ContentComponent: AnrokConfigurationForm,
  Footer: AnrokConfigurationFooter,
};
